import { Button, ButtonProps } from '@material-ui/core';
import React from 'react';

export const MediumPrimaryTextButton = (props: ButtonProps) => {
	return (
		<Button
			variant='text'
			size='medium'
			color='primary'
			{...props}
		/>
	);
};
